// extracted by mini-css-extract-plugin
export var articleBlock = "lcArticleBlock-module--articleBlock--ddacc";
export var articleBlockTitle = "lcArticleBlock-module--articleBlockTitle--afc3e";
export var caret = "lcArticleBlock-module--caret--d549e";